<template>
    <div class="DistrictsEditor">		
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Районов: {{ApiData.length}}</span>
		</div>
		<div class="col-md-12" v-show="bShowFilter"><ReFilter :masAllFilterParams="masAllFilterParams" v-model="objGetParams" v-on:filterapply="OnFilterApply"/></div>

		<card >
			<div v-if=(!canNotEdit)>
				<h5 v-if="isEdit==false"><i class="tim-icons icon-send text-success mr-3"></i>Добавление района</h5>
				<h5 v-else><i class="tim-icons icon-send text-success mr-3"></i>Редактирование района</h5>
			</div>
			<form action="" ref="form">
				<div class="row justify-content-between align-items-center" v-if=(!canNotEdit)>
					<div class="col-md mb-2">
						<base-input 
							type="text" 
							autocomplete="off" 
							placeholder="Название района" 
							v-on:change="disabledCreateBtn"
							v-model="objDistr.distrName">
						</base-input>
					</div>
					<div class="col-md mb-2">
						<el-select 
								class="w-100 px-0 select-primary"
								v-model="zipal" 
								placeholder="Район в зипале"
								size="large"
								filterable
								clearable
							>
							<el-option
								class="select-primary"
								v-for="district in zipalData"
								:key="district.id"
								:label="district.name"
								:value="district.id"
								>
							</el-option>
						</el-select>
					</div>			
					<div class="col-md mb-2">
						<base-input 
							type="text" 
							autocomplete="off" 
							placeholder="Числовой код в БКН" 
							v-model="objDistr.bkn">
						</base-input>
					</div>

					<div class="d-flex px-3 mb-3">
						<button v-if="isEdit==false" :disabled="disabled" class="btn btn-success btn-simple mr-3" type="button" @click="createDistrict()">Создать</button>
						<button v-else class="btn btn-success btn-simple mr-3" type="button" @click="updDistr()">Сохранить</button>
						<button class="btn btn-danger btn-simple" type="button" @click="cancelDistr()">Отменить</button>
					</div>
				</div>
				<div class="cellmap-wrapper">				
					<div class="cellmap"> 
						<re-cell-map-editor ref="cellEditor" :cells="ApiData" :readonly="canNotEdit" v-model="polygon" ></re-cell-map-editor>
					</div>
				</div>
			</form>
			
		</card>

		<card class="CellAdd-table">
			<el-table 
				:data="ApiData" 
				:highlight-current-row="false" 
				:cell-style="{height:'100px'}" 
				style="width: 100%;" 
				class="el-table--scrollable-x">
				<el-table-column
					sortable
					width="80"
					label="ИД"
					property="id"
				></el-table-column>
				<el-table-column
					sortable
					width="80"
					label="ИД от Зипал"
					property="zipal"
				></el-table-column>
				<el-table-column
					sortable
					min-width="180"
					label="Название района"
					property="cellName"
				></el-table-column>
				<el-table-column
					min-width="180"
					label="На карте"
					property="cellStyle"
				>
					<template v-slot="scope">	
						<base-button class="ml-3 btn btn-simple btn-primary" @click="showThisCell(scope.$index, scope.row)">
							<i class="tim-icons icon-square-pin"></i>
							Показать на карте
						</base-button>											
					</template>
				</el-table-column>
				<el-table-column
					min-width="240"
					height="100"
					label="Координаты района"
					property="cellValues"
				></el-table-column>
				<el-table-column
					width="80"
					label=""
					v-if=(!canNotEdit)
				>	
					<template v-slot="scope">						
						<el-tooltip content="Редактировать район" placement="top">
							<el-button class="no-border my-0">
								<base-button  class="ml-3 btn btn-icon btn-simple btn-primary" @click="editDistr(scope.$index, scope.row)">
									<i class="tim-icons icon-pencil"></i>
								</base-button>											
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<!--el-table-column
					min-width="80"
					label="agent_id"
					property="agent_id"
				>	
				</el-table-column-->
				<el-table-column
					width="110"
					label="Действие"
					align="right"      
					v-if=(!canNotEdit)              	
				>
					<template v-slot="scope">						
						<ReActionBtns :masActions="masActions[scope.$index]"/>
					</template>
				</el-table-column>
			</el-table>
			<!-- <Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination> -->
		</card>
		
    </div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button, Popover, Input } from 'element-ui';
// import { BaseSwitch } from 'src/components';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';
import ReCellMapEditor from 'src/our_components/ReCellMapEditor.vue';

import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import Pagination from 'src/our_components/RePagination';

export default {
	name: 'districts_editor-page',
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		[Popover.name]: Popover,
		[Input.name]: Input,
		// BaseSwitch,
		ReActionBtns,
		ReCellMapEditor,
		ReFilterBtn,
        ReFilter,
        // ReFormPrinter,
        // Pagination,
	},
	data() {
		return {
			ApiData: [],
			zipalData: [],
			zipal: '',
			masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			objDistr: {},
			polygon:'[]',
			curDistr: [],
			masActions:[],	
			bShowFilter: false,
			// masDistrictsAdd: [],
			isEdit: false,
			canNotEdit: false,
			masObjects_total: 0,
			count2page: 10,
			disabled:true,
			
		};
	},
	methods: {
		getApiData(){
			let filter = {list:true};
			this.objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
				filter = {...filter, ...this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams))};
			}					
			this.$GVO.ApiCall('cat_districts.GET',{flt:{...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;

						this.masActions = [];
						for (let i = 0; i < this.ApiData.length; i++) {
							this.masActions.push([
								{
									actionType: 'switcher',
									label_on: 'Вкл',
									label_off: 'Выкл',
									action_model: this.ApiData[i].act=='1'?true:false,						
									onClickApi: {apiMethod: 'CHANGE_ACT_RESTRICTIONS',apiParam:{obj:'cat_districts',flt:{id:this.ApiData[i].id}}},
								},
							]);
						}

						if(objApi.readonly == 1){
							this.canNotEdit = true;
						}else {this.canNotEdit = false;}
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
			this.zipalData = [];
			this.$GVO.ApiCall('cat_districts.ZIPAL_GET',{flt:{...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.zipalData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));					
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('cat_districts.GET_FILTER',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},			
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},

		getSaveData(){
			const iData = {
				id: this.objDistr.id,
				name: this.objDistr.distrName,
				act: this.objDistr.distrAct,
				value: this.polygon,
				zipal: this.zipal,	
			}

			const objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(objGetParams)) {
				iData.region=objGetParams.region
			}			

			return iData;
		},
		disabledCreateBtn(){
			this.disabled=true;
			if(this.objDistr.distrName != ''){
				this.disabled = false;
			} /*else {this.disabled = true; this.$GVO.showAlert('Данные не заполнены','<p>Заполните название района</p>')};*/
		},
		createDistrict() {
			const iData= this.getSaveData();			
			this.$GVO.ApiCall('INS', {obj:'cat_districts', iData })
			.then((objApi) => {
				if(objApi.success === true){
					this.cancelDistr();
					this.getApiData();
					/*
					if(objApi.data.length > 0) {
						this.masMetrosAdd = objApi.data;			
					}
					this.getApiData();					
					this.objMetro.metroName = '';
					this.polygon = '[]';
					this.$refs.cellEditor.startEdit();		
					*/		
				}else {
					this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на создание районов.</p>')
				} 
									
			}).catch(errorObjApi => console.error(errorObjApi));			
			// this.$GVO.ApiCall('INS', {obj:'MAP_CELLS', iData:{
			// 		id: this.objDistr.id,
			// 		distrName: this.objDistr.distrName,
			// 		act: this.objDistr.cellAct,
			// 		distrValues: this.polygon,		
			// 		agent_id: this.agent_id,					
			// 		}
			// 	}
			// )
			// .then((objApi) => {
			// 	if(objApi.success === true){
			// 		if(objApi.data.length > 0) {
			// 			this.masDistrictsAdd = objApi.data;			
			// 		}
			// 		this.getApiData();					
			// 		this.objDistr.distrName = '';
			// 		this.polygon = '[]';
			// 		this.$refs.cellEditor.startEdit();				
			// 	}else {
			// 		this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на создание и редактирование районов.</p>')
			// 	} 
									
			// }).catch(errorObjApi => console.log(errorObjApi));
			// console.log('Функция добавляет район. Нужен INS, {obj:}');
		},
		cancelDistr(){
			this.polygon = '[[[]]]';
			this.isEdit = false;
			this.objDistr.distrName = '';
			this.objDistr.id = '';
			this.zipal='';
			this.disabled=true;
		},
		editDistr(index, row){
			// console.log(row);
			this.polygon = row.cellValues;
			this.isEdit = true;
			this.objDistr = Object.assign(
				{},
				this.objDistr,
				{
					distrName: row.cellName,
					id: row.id,
				}
			);
			this.zipal = row.zipal;
			this.$refs.cellEditor.startEdit(true);
			this.$refs.form.scrollIntoView({behavior: 'smooth', block: 'center'});
		},
		updDistr() {
			const uData= this.getSaveData();
			// this.metroName = this.objMetro.metroName;
			// this.metroValues = this.polygon;
			// this.id = this.objMetro.id;

			this.$GVO.ApiCall('UPD', {obj:'cat_districts',flt:{id: this.id}, uData	})
			.then((objApi) => {
				if(objApi.success === true){
					this.cancelDistr();
					this.getApiData();
				}else {
					this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на редактирование районов.</p>')
				} 
									
			}).catch(errorObjApi => console.error(errorObjApi));

			// console.log('Функция добавляет район. Нужен UPD, {obj:}');
		},
		showThisCell(index, row){
			//При клике на строке таблицы сот (на кнопку), стирать на карте все ячейки и отображать только текущую.
			//по строке потом будет ховер с данными, поэтому при клике по кнопке выделяем цветом полигон на карте

			this.objDistr.id = row.id;
			this.objDistr.cellValues = row.cellValues;

			for (let i = 0; i < this.ApiData.length; i++) {
				if(this.ApiData[i].id == this.objDistr.id){
					this.ApiData[i].cellStyle = '#FF8D72'; 
					
					this.$refs.cellEditor.drawCells();
					this.$refs.cellEditor.focus(this.ApiData[i].cellValues);
					// this.$refs.cellEditor.zoomMap();
					
					this.$refs.form.scrollIntoView({behavior: 'smooth', block: 'center'});
					// this.zoomMap();
				
				} else {
					this.ApiData[i].cellStyle = ''; 
				}
			}
			
		},
		formatter (row, column) {
			return row.id;
		},
		// zoomMap(index, row){
        //     let polygon=JSON.parse(this.objDistr.cellValues)
        //     this.map.setBounds(polygon.editor.geometry.getBounds(),{
        //         duration:500,
        //         zoomMargin:[100,500],
        //     })
        // },

	},	
	watch:{
		polygon(val){
		}
	},		
	mounted() {
		// this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
		// this.disabledCreateBtn();
	}
};
</script>
<style>
.DistrictsEditor .cellmap-wrapper {
	position: relative;
	width: 100%;
	height:  100%;
	padding: 0 20px;
}
.DistrictsEditor .btn-cellmap {
	position: absolute;
	right: 110px;
	top: 5px;
}
.DistrictsEditor .form-group {margin-bottom: 0;}

</style>
